import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'icon-tick-circle',
  props: {
  width: {
    type: String,
    default: 'w-6',
  },
  height: {
    type: String,
    default: 'h-6',
  },
  color: {
    type: String,
    default: 'text-current',
  },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})